<template>
  <div class="container justify-content-center mt-5">
    <div class="row d-flex justify-content-center company-product-payment-success-page">
      <div class="col-md-8 mt-3">
        <h3 class="text-center mb-4 page-title">{{ $t(LangConstants.purchase_could_not_completed_heading) }}</h3>
        <p class="mb-5 text-center page-desc">
          {{ $t(LangConstants.purchase_could_not_completed_text) }}
        </p>

        <div class="row">
          <div class="col-md-12 text-center">
            <div class="mb-2">
              <my-button fa="" :label="$t(LangConstants.contact_us_button_label)" variant="box-primary" classes="mr-1" height="64px" minwidth="400px"></my-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Webshop Payment Failed Page
 */
import "../../../../assets/scss/companyproductpaymentsuccesspage.scss";
import MyButton from "../../../../components/atoms/Button.vue";
import common from "../../../../functions/index";
import Constants from "../../../../constants/index";
// import Csrf from "../../../../apis/Csrf";

export default {
  name: "webshop-payment-success",
  async created() {
    try {
      const trType = this.$route.params.type;
      const id = this.$route.params.id;
      let formData = common.getFromLocalStorage(this.$route.params.id);
      console.log(id);

      switch (trType) {
        case "card":
          {
            this.handleStripeCardPayment(self, formData, trType);
          }

          break;

        case "woocommerce_integration":
          {
            this.handleWoocommerceFailedPayment(self, formData, trType);
          }
          break;
      }
    } catch (error) {
      this.$fire({
        title: this.$t(this.LangConstants.retrieving_session_error_heading),
        text: this.$t(this.LangConstants.stripe_api_error_text),
        type: "error",
        html: "",
      });
    }
  },

  methods: {
    async handleStripeCardPayment(self, formData, trType) {
      let sessData = await this.$store.dispatch("getStripeCheckoutSession", { id: this.$route.params.id, connectedAccount: this.$route.params.connectedAccount });

      this.paymentIntent = await this.$store.dispatch("getStripePaymentIntent", { id: sessData["payment_intent"], StripeAccount: this.$route.params.connectedAccount });

      let payload = {
        webshop_payment: {
          order_reference_id: this.paymentIntent.data.id,
          instance_id: formData.user.instance_id,
          user_id: 0,
          date_paid: 0,
          status: "failed",
          method: trType,
          return_log: JSON.stringify(this.paymentIntent),
        },
        stripe_connect_account_id: this.$route.params.connectedAccount,
        webshop_id: formData.product.webshopId,
        charge_id: sessData["payment_intent"],
        payment_intent_response: JSON.stringify(this.paymentIntent.data),
      };

      this.$store
        .dispatch("createWebshopPayment", JSON.stringify(payload))
        .then(() => {
          // common.deleteFromLocalStorage(this.$route.params.id)
        })
        .catch((error) => {
          this.$fire({
            title: this.$t(this.LangConstants.payment_status_heading),
            text: this.$t(this.LangConstants.create_webshop_payment_failed_text),
            type: "error",
            html: "<div>" + this.$t(error) + "</div>",
          });
        });
    },

    async handleWoocommerceFailedPayment(self, formData, trType) {
      let quantity = (!formData.product.quantity)? 1 : formData.product.quantity;
      this.productName = formData.product.productName;
      this.orderNumber = formData.payment.preorderid;
      let amount = (formData.product.discount_amount ? formData.product.amount - formData.product.discount_amount : formData.product.amount) * quantity;
      this.totalCost = common.formatMoney(parseFloat(amount).toFixed(2), common.toUpperCase(formData.product.currency));

      let payload = {
        webshop_payment: {
          order_reference_id: this.orderNumber,
          instance_id: formData.user.instance_id,
          date_paid: Date.now(),
          status: "failed",
          method: trType,
          return_log: JSON.stringify({}),

          event_id: formData.product.event_id,
          total: amount,
          sub_total: formData.product.amount * quantity,
          discount: formData.product.discount_amount,
          currency: formData.product.currency,
          quantity: formData.product.quantity,
        },
        stripe_connect_account_id: null,
        webshop_id: formData.product.webshopId,
        charge_id: this.chargeId,
        payment_intent_response: JSON.stringify({}),
        participants: formData.participants,
      };

      formData.user.lms_url = window.location.origin;
      formData.user.phone_1 = formData.user.phone;

      this.payment = await this.$store.dispatch("createWebshopPayment", JSON.stringify(payload));
    },
  },

  computed: {
    LangConstants() {
      return Constants;
    },
  },

  components: {
    MyButton,
  },
};
</script>
